function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.99967 0.333374C3.31301 0.333374 0.333008 3.31337 0.333008 7.00004C0.333008 10.6867 3.31301 13.6667 6.99967 13.6667C10.6863 13.6667 13.6663 10.6867 13.6663 7.00004C13.6663 3.31337 10.6863 0.333374 6.99967 0.333374ZM8.72634 4.33337L6.99967 6.06004L5.27301 4.33337L4.33301 5.27337L6.05967 7.00004L4.33301 8.72671L5.27301 9.66671L6.99967 7.94004L8.72634 9.66671L9.66634 8.72671L7.93967 7.00004L9.66634 5.27337L8.72634 4.33337ZM1.66634 7.00004C1.66634 9.94004 4.05967 12.3334 6.99967 12.3334C9.93967 12.3334 12.333 9.94004 12.333 7.00004C12.333 4.06004 9.93967 1.66671 6.99967 1.66671C4.05967 1.66671 1.66634 4.06004 1.66634 7.00004Z",
  fill: "#2D3134"
});

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.6cd4a701.svg";
export { ForwardRef as ReactComponent };